import React from 'react';
import DocsContext from './src/contexts/DocsContext';
import useLocalStorage from './src/hooks/useLocalStorage';
import Layout from './src/components/Layout/Layout';

const Wrapper = props => {
  const [defaultShowsCode, setDefaultShowsCode] = useLocalStorage('defaultShowsCode', false);
  const [defaultComponentTab, setDefaultComponentTab] = useLocalStorage('defaultComponentTab', 'examples');
  const [defaultPropsSort, setDefaultPropsSort] = useLocalStorage('defaultPropsSort', 'significance');
  const [userRole, setUserRole] = useLocalStorage('userRole', '');
  const [editorStyle, setEditorStyle] = useLocalStorage('editorTheme', 'dark');
  const [userName, setUserName] = useLocalStorage('userName', '');
  const [updateAvailable, setUpdateAvailable] = React.useState(false);
  const [isDarkPage, setIsDarkPage] = React.useState(false);
  const [isPreferencesModalOpen, setIsPreferencesModalOpen] = React.useState(false);

  React.useEffect(() => {
    window.INK_NOTIFY_NEW_VERSION = () => setUpdateAvailable(true);
    return () => {
      window.INK_NOTIFY_NEW_VERSION = undefined;
    };
  });

  const value = {
    defaultShowsCode,
    setDefaultShowsCode,
    defaultComponentTab,
    setDefaultComponentTab,
    defaultPropsSort,
    setDefaultPropsSort,
    userRole,
    setUserRole,
    editorStyle,
    setEditorStyle,
    userName,
    setUserName,
    updateAvailable,
    isDarkPage,
    setIsDarkPage,
    isPreferencesModalOpen,
    setIsPreferencesModalOpen,
  };

  return <DocsContext.Provider value={value}>{props.children}</DocsContext.Provider>;
};
export const wrapRootElement = ({ element }) => {
  return <Wrapper>{element}</Wrapper>;
};

export const wrapPageElement = ({ element }) => {
  // Some pages (currently just the dark themed ones) have an added skipDefaultLayout
  // boolean property which lets them opt out of the Layout wrapper
  if (element?.type?.skipDefaultLayout) {
    return element;
  }

  // Wrap all other pages with Layout for persistent SideNavigation
  return <Layout>{element}</Layout>;
};

export const onServiceWorkerUpdateFound = () => {
  typeof window !== 'undefined' && window.INK_NOTIFY_NEW_VERSION && window.INK_NOTIFY_NEW_VERSION();
};

export const onRouteUpdate = ({ location }) => {
  // Handle hash navigation after content has rendered
  if (location.hash) {
    const id = location.hash.slice(1);

    // Wait for next frame to ensure React has rendered the content
    requestAnimationFrame(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
};
